import React, { Component } from 'react';
import { compose } from 'redux'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import withAuth from '../../components/withAuth';
import { getCurrentFunctionName } from '../../performanceModeManager';
import { Card, CardContent, CardHeader } from '@material-ui/core';
import CustomizedTextField from '../../components/Input/CustomizedTextField';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import AffairStatusIcon from '../../components/Affairs/AffairStatusIcon';
import { formatStatus, getColorFromStatusLabel } from '../../redux/affair/affairStatus';
import '../../statusIcon.css'
import AffairAdditionnalFields from '../../components/Affairs/AffairAdditionnalFields';
import ContractAdditionnalFields from '../../components/Affairs/ContractAdditionnalFields';
import { CONTRACT_TYPE } from '../../redux/affair/affairConstants';
import { formatAmountToString } from '../../utils';
import ExtranetInterventions from '../Interventions/ExtranetInterventions'
import Invoices from '../Invoices/Invoices'
import { clearAffair } from '../../redux/affair/affairActions';
import Inspections from '../../components/Affairs/Inspections';

class Affair extends Component {

    constructor(props) {
        super(props);

        if (!props.affair)
            props.history.push("/affairs");
    }

    componentDidUpdate(prevProps) {
        if (prevProps.sites.selectedSite !== this.props.sites.selectedSite)
            this.props.history.push("/affairs");
    }

    componentWillUnmount() {
        this.props.clearAffair();
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        if (!this.props.affair)
            return null;


        let interventionsElement = (
            <Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding-only-small-screen">
                <CardHeader title={"Intervention(s) associée(s)"} titleTypographyProps={{ variant: "h5", color: 'primary' }} />
                <CardContent className="without-side-padding-only-small-screen">
                    <ExtranetInterventions {...this.props} withoutFilters />
                </CardContent>
            </Card>
        )

        let invoicesElement = (
            < Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding-only-small-screen" >
                <CardHeader title={"Facture(s) associée(s)"} titleTypographyProps={{ variant: "h5", color: 'primary' }} />
                <CardContent className="without-side-padding-only-small-screen">
                    <Invoices {...this.props} withoutFilters />
                </CardContent>
            </Card >
        )

        let additionnalFieldsElement = (<AffairAdditionnalFields />);

        if (this.props.affair.affair_type === CONTRACT_TYPE)
            additionnalFieldsElement = (<ContractAdditionnalFields />);

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding-only-small-screen">
                <Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding-only-small-screen">
                    <CardHeader title={this.props.affair.name} titleTypographyProps={{ variant: "h4", color: 'primary' }} />
                    <CardContent className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding without-side-padding-only-small-screen">
                        <div className="row div-center">
                            <div className="col-lg-4 col-md-6 col-sm-12 col-12 control-margin-top">
                                <CustomizedTextField
                                    id="code"
                                    label="Code"
                                    className="full_size light-disabled"
                                    value={this.props.affair.code}
                                    margin="normal"
                                />
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 col-12 control-margin-top">
                                <CustomizedTextField
                                    id="name"
                                    label="Désignation"
                                    className="full_size light-disabled"
                                    value={this.props.affair.name}
                                    margin="normal"
                                />
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 col-12 control-margin-top">
                                <MuiPickersUtilsProvider
                                    locale={"fr"}
                                    utils={MomentUtils}
                                    moment={moment}
                                >
                                    <DatePicker
                                        name="date-signed"
                                        value={this.props.affair.date_signed}
                                        label="Date de signature"
                                        clearLabel="Effacer"
                                        invalidDateMessage="La date est invalide"
                                        invalidLabel="La date est invalide"
                                        cancelLabel="Annuler"
                                        format="DD/MM/YYYY"
                                        className="col-lg-12 col-md-12 col-sm-12 col-12 light-disabled"
                                        margin="normal"
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 col-12 control-margin-top">
                                <CustomizedTextField
                                    id="type"
                                    label="Type"
                                    className="full_size light-disabled"
                                    value={this.props.affair.affair_type}
                                    margin="normal"
                                />
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 col-12 control-margin-top div-status-icon">
                                <AffairStatusIcon state={this.props.affair.state} className="status-icon" />
                                <span className={"status-icon-color-" + getColorFromStatusLabel(this.props.affair.state)} >
                                    {formatStatus(this.props.affair.state)}
                                </span>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 col-12 control-margin-top">
                                <CustomizedTextField
                                    id="amount"
                                    label="Montant"
                                    className="full_size light-disabled"
                                    value={formatAmountToString(this.props.affair.planned_sales_amount)}
                                    margin="normal"
                                />
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 col-12 control-margin-top">
                                <MuiPickersUtilsProvider
                                    locale={"fr"}
                                    utils={MomentUtils}
                                    moment={moment}
                                >
                                    <DatePicker
                                        name="date-start"
                                        value={this.props.affair.date_start}
                                        label="Date de début"
                                        clearLabel="Effacer"
                                        invalidDateMessage="La date est invalide"
                                        invalidLabel="La date est invalide"
                                        cancelLabel="Annuler"
                                        format="DD/MM/YYYY"
                                        className="col-lg-12 col-md-12 col-sm-12 col-12 light-disabled"
                                        margin="normal"
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 col-12 control-margin-top">
                                <MuiPickersUtilsProvider
                                    locale={"fr"}
                                    utils={MomentUtils}
                                    moment={moment}
                                >
                                    <DatePicker
                                        name="date-end"
                                        value={this.props.affair.date_end}
                                        label="Date de fin"
                                        clearLabel="Effacer"
                                        invalidDateMessage="La date est invalide"
                                        invalidLabel="La date est invalide"
                                        cancelLabel="Annuler"
                                        format="DD/MM/YYYY"
                                        className="col-lg-12 col-md-12 col-sm-12 col-12 light-disabled"
                                        margin="normal"
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                            {additionnalFieldsElement}

                        </div>
                    </CardContent>
                </Card>
                {this.props.affair.affair_type === CONTRACT_TYPE ? (
                    <>
                        <Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding-only-small-screen">
                            <CardHeader title={"Visite(s) associée(s)"} titleTypographyProps={{ variant: "h5", color: 'primary' }} />
                            <CardContent className="without-side-padding-only-small-screen">
                                <Inspections globalStore={this.props.globalStore}/>
                            </CardContent>
                        </Card>
                        {interventionsElement}
                        {invoicesElement}
                    </>
                ) : (
                    <>
                        {invoicesElement}
                        {interventionsElement}
                    </>
                )}
            </div >
        )
    }
}

const mapStateToProps = (state) => {
    return {
        affair: state.affair.currentAffair,
        sites: state.sites,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearAffair: () => dispatch(clearAffair()),
    };
};

export default compose(withAuth, withRouter, connect(mapStateToProps, mapDispatchToProps))(Affair);
